module.exports = __webpack_public_path__ + "img/skin-detail-msu-review-avatar.ef34655.jpg";